.toolbar {
  max-width: 1400px;
  margin: 0 auto 32px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.searchWrap {
  position: relative;
  flex: 1;
}

.search {
  width: 100%;
  padding: 8px 16px 8px 44px;
  background: var(--ps-bg-card);
  border: 1px solid var(--ps-border-default);
  border-radius: var(--ps-radius-xl);
  color: var(--ps-text-primary);
  font-size: var(--ps-text-base);
  outline: none;
  transition: border-color var(--ps-duration-base);
}

.search:focus {
  border-color: var(--ps-green);
}

.search::placeholder {
  color: var(--ps-text-muted);
}

.searchIcon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--ps-text-muted);
}

.count {
  font-size: 12px;
  color: var(--ps-text-muted);
  white-space: nowrap;
}

.viewToggle {
  display: flex;
  align-items: center;
  gap: 4px;
  background: var(--ps-bg-elevated);
  border-radius: var(--ps-radius-md);
  padding: 2px;
  flex-shrink: 0;
}

.viewBtn {
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  background: transparent;
  color: var(--ps-text-muted);
}

.viewBtnActive {
  background: var(--ps-bg-card);
  color: var(--ps-text-primary);
  box-shadow: var(--ps-shadow-sm);
}
